import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action sets, overwrites, or removes any existing value for `}<inlineCode parentName="p">{`customerEmail`}</inlineCode>{`.`}<br parentName="p"></br>{`
`}{`This action does not change the customer email on the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#cart"
        }}>{`Cart`}</a>{` the order has been created from.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setCustomerEmail"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`email`}</inlineCode>{` - String - Optional`}</li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/message-types#ordercustomeremailsetmessage"
        }}>{`OrderCustomerEmailSetMessage`}</a>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      